<template>
<div class="crawled-info--wrapper" v-if="value">
  <div class="crawled-info--label">
    {{$t('models.project_lead.crawled_infos.' + label)}}
  </div>
  <div class="crawled-info--value">
    {{value}}
  </div>
</div>
</template>
<script>
export default{
  props: ['label','value']
}
</script>
<style lang="scss">
.crawled-info--label{
  color: #7c7c7c;
  font-size: 22px;
}

.crawled-info--value{
  font-size: 18px;
}


.linkedin_link .crawled-info--value{
  color: #2e7bae;
  text-decoration: none;
}

</style>


// WEBPACK FOOTER //
// CrawledInfo.vue?19b665e0